export default "__VITE_ASSET__DPaCT8RQ__"